import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Box, CircularProgress, Typography, Alert } from '@mui/material';
import { storeTokens, getUserPermissions, clearTokens } from '../utils/api';
import {
  getKioskHomePath,
  isKioskMode,
  isKioskSupportedUser,
} from '../utils/kioskMode';

const KivoCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState({ loading: true, message: 'Finalizing Kivo login...', error: null });

  useEffect(() => {
    const finalizeLogin = async () => {
      const accessToken = searchParams.get('access_token');
      const refreshToken = searchParams.get('refresh_token') || '';
      const rawUser = searchParams.get('user');

      if (!accessToken) {
        setStatus({ loading: false, error: 'Missing access token in callback.', message: null });
        return;
      }

      let userPayload = null;
      if (rawUser) {
        try {
          userPayload = JSON.parse(rawUser);
        } catch (err) {
          console.warn('Unable to parse user payload from Kivo callback', err);
        }
      }

      try {
        storeTokens(accessToken, refreshToken);
        if (userPayload) {
          localStorage.setItem('user', JSON.stringify(userPayload));
        }

        let next = '/dashboard';
        if (isKioskMode()) {
          const permissions = await getUserPermissions();
          if (!isKioskSupportedUser(permissions)) {
            clearTokens();
            setStatus({
              loading: false,
              error: 'This kiosk supports admin or intrusion accounts only.',
              message: null,
            });
            return;
          }
          next = getKioskHomePath(permissions);
        }

        setStatus({ loading: true, message: 'Redirecting...', error: null });
        setTimeout(() => {
          navigate(next, { replace: true });
        }, 300);
      } catch (err) {
        setStatus({ loading: false, error: err.message || 'Failed to complete login.', message: null });
      }
    };

    finalizeLogin();
  }, [navigate, searchParams]);

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
        {status.error ? (
          <Alert severity="error">{status.error}</Alert>
        ) : (
          <>
            <CircularProgress sx={{ mb: 3 }} />
            <Typography variant="h6">{status.message}</Typography>
          </>
        )}
      </Box>
    </Container>
  );
};

export default KivoCallback;
